export default "__VITE_ASSET__Bnb6MYWL__"